import { render, staticRenderFns } from "./changelog-item.vue?vue&type=template&id=6e204f7b&scoped=true"
import script from "./changelog-item.vue?vue&type=script&lang=ts"
export * from "./changelog-item.vue?vue&type=script&lang=ts"
import style0 from "./changelog-item.vue?vue&type=style&index=0&id=6e204f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e204f7b",
  null
  
)

export default component.exports